import {
  FlexProps,
  HeadingProps,
  TextField,
  type TextProps as RadixTextProps,
} from '@radix-ui/themes';

export type RadixColors = NonNullable<HeadingProps['color']>;
export type RadixTextSize = NonNullable<RadixTextProps['size']>;
export type RadixPositions = NonNullable<FlexProps['position']>;
export type RadixTextWeight = NonNullable<RadixTextProps['weight']>;
export type TextFieldProps = React.ComponentProps<typeof TextField.Root>;

export interface SimpleTextFieldProps extends Omit<
  TextFieldProps,
  'onChange' | 'onBlur' | 'onFocus'
> {
  onChange: (value: string) => void;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const sizeMapper = {
  sm: '1',
  md: '2',
  lg: '3',
  xl: '4',
  icon: '2',
} as const;

export type ButtonSize = keyof typeof sizeMapper;
